/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponsePagedResultAdministrator } from '../../models/api-response-paged-result-administrator';
import { PagedRequestAdministrator } from '../../models/paged-request-administrator';

export interface SearchAdministrator$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: PagedRequestAdministrator
}

export function searchAdministrator(http: HttpClient, rootUrl: string, params: SearchAdministrator$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultAdministrator>> {
  const rb = new RequestBuilder(rootUrl, searchAdministrator.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponsePagedResultAdministrator>;
    })
  );
}

searchAdministrator.PATH = '/v1/api/admin-ui/administrator/search';
